import { Pipe, PipeTransform } from '@angular/core';
import { LocaleService } from '../services/locale.service';

@Pipe({
  name: 'localeDate',
  standalone: false
})
export class LocaleDatePipe implements PipeTransform {
  constructor(private localeService: LocaleService) {}

  transform(
    value: Date | string | number,
    format: 'date' | 'datetime' | 'datetime-dropdown' | 'time' | 'time-seconds' | 'short' = 'date'
  ): string {
    if (!value) return '';

    switch (format) {
      case 'datetime':
        return this.localeService.formatDateTime(value);
      case 'short':
        return this.localeService.formatDateShort(value);
      case 'time':
        return this.localeService.formatTime(value);
      case 'time-seconds':
        return this.localeService.formatTimeWithSeconds(value);
      case 'date':
      default:
        return this.localeService.formatDate(value);
    }
  }
}
